import { useOutletContext } from 'react-router';
import { Case } from '../types/Case/Case.type';

export interface CaseWorkspaceContext {
  caseData?: Case;
  isLoadingCase: boolean;
  selectedDisparityId: number | null;
  selectedResourceId: number | null;
  onDisparitySelect: (disparityId: number) => void;
  onResourceSelect: (resourceId: number) => void;
  onUnselect: () => void;
  isSsbEnabled: boolean;
}

export function useCaseWorkspace() {
  return useOutletContext<CaseWorkspaceContext>();
}

export default useCaseWorkspace;
